import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@byaft/ui/styles/base.css';
import './index.css';
import { App } from './App';
import { applyStoredConsent } from './lib/consent';

// Re-apply a previously granted analytics consent before the app renders.
applyStoredConsent();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
